import type { ReactElement } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { NotFound } from '@ohpen/enso-ui';

import { defaultSectionPath, visibleSections } from '@config/navigation';
import { useConfigContext } from '@config/context';
import {
  AuditLogPage,
  CustomFieldsPage,
  FeatureFlagsPage,
  ParametersPage,
  PermissionsPage,
  RolesPage,
  TranslationsPage,
  UsersPage,
  ValueListsPage,
} from '@config/pages';

const ELEMENT_BY_SECTION: Record<string, ReactElement> = {
  roles: <RolesPage />,
  permissions: <PermissionsPage />,
  users: <UsersPage />,
  featureFlags: <FeatureFlagsPage />,
  parameters: <ParametersPage />,
  valueLists: <ValueListsPage />,
  translations: <TranslationsPage />,
  customFields: <CustomFieldsPage />,
  auditLog: <AuditLogPage />,
};

/**
 * Paths are relative to the mount point, so the module keeps working wherever it is mounted.
 * A section the account may not open is never registered, so its URL falls through to the
 * catch-all instead of rendering behind a hidden menu entry.
 */
export const ConfigRoutes = (): ReactElement => {
  const { canViewSection } = useConfigContext();
  const landing = defaultSectionPath(canViewSection);

  return (
    <Routes>
      <Route index element={landing ? <Navigate to={landing} replace /> : <NotFound />} />
      {visibleSections(canViewSection).map(section => (
        <Route key={section.key} path={section.path} element={ELEMENT_BY_SECTION[section.key]} />
      ))}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
